import React from "react";
import { trackEvent } from "../../analytics";
import { buildWhatsAppSendUrl } from "../../lib/whatsAppShare";

/**
 * Opens WhatsApp with a prefilled message. On desktop (fine pointer), opens in a new tab;
 * on touch devices, navigates the current window for reliable app handoff.
 * @param {object} props
 * @param {string} props.whatsappMessage Full message text for WhatsApp (incl. link)
 * @param {'event_story'|'event'|'news'|'briefing'} props.scenario Analytics dimension
 * @param {string} props.shareUrl Canonical URL being shared (analytics + debugging)
 * @param {string} [props.label] Button text (defaults to "Schicke an Freunde!")
 */
export default function ShareButton({ whatsappMessage, scenario, shareUrl, label }) {
  const handleClick = (e) => {
    e.stopPropagation(); // prevent fullscreen toggle
    trackEvent("share_whatsapp", { scenario });
    const waUrl = buildWhatsAppSendUrl(whatsappMessage);
    const openInNewTab =
      typeof window !== "undefined" &&
      window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    if (openInNewTab) {
      // Do not pass noopener/noreferrer in the features string: spec requires
      // window.open to return null then, which breaks popup-blocked detection
      // and wrongly triggers the same-tab fallback.
      const handle = window.open(waUrl, "_blank");
      if (handle) {
        handle.opener = null;
      } else {
        window.location.href = waUrl;
      }
    } else {
      window.location.href = waUrl;
    }
  };

  return (
    <button type="button" className="share-button" onClick={handleClick}>
      <svg viewBox="0 0 24 24" aria-hidden>
        <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7 0-.24-.03-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 
        1.66 0 3-1.34 3-3s-1.34-3-3-3-3 
        1.34-3 3c0 .24.03.47.09.7L8.04 
        9.81C7.5 9.31 6.79 9 6 9c-1.66 
        0-3 1.34-3 3s1.34 3 3 
        3c.79 0 1.5-.31 2.04-.81l7.12 
        4.16c-.06.22-.1.45-.1.68 0 1.66 
        1.34 3 3 3s3-1.34 3-3-1.34-3-3-3z"/>
      </svg>
      {label || "Schicke an Freunde!"}
    </button>
  );
}
